import { Component, OnInit, ViewEncapsulation, Input, ContentChildren, QueryList } from '@angular/core';
import { IdService } from '../../../shared/services/id.service';
import { SnackbarComponent } from '../snackbar.component';

@Component({
	selector: 'rbc-snackbar-container',
	templateUrl: './snackbar-container.component.html',
	styleUrls: ['./snackbar-container.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class SnackbarContainerComponent implements OnInit {
	@Input() id: string;
	classes: string[] = [];

	@ContentChildren(SnackbarComponent) snackbars: QueryList<SnackbarComponent>;

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	ngOnInit() {}

	ngAfterContentInit(): void {
		if (this.snackbars && this.snackbars.first) {
			const arr = this.snackbars.first.classGen();
			// add position classes to array
			this.classes.push(arr[0], arr[1]);
		}
	}
}
